import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { Sheet, SheetContent, SheetTrigger, SheetTitle } from "@/components/ui/sheet";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_villa-surveillance/artifacts/27e1elgx_Logo.png";

const navLinks = [
  { label: "À propos", href: "#apropos" },
  { label: "Nos Services", href: "#offres" },
  { label: "Contact", href: "#coordonnees" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 80);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollTo = (href) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <nav
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#2E3A34] shadow-lg"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between h-44">
        <a href="#accueil" onClick={() => scrollTo("#accueil")} className="flex items-center" data-testid="navbar-logo">
          <div className="h-32 md:h-36 w-44 md:w-52 overflow-hidden flex items-center justify-center">
            <img src={LOGO_URL} alt="AŪRA HOME CARE" className="h-[220%] w-auto max-w-none" />
          </div>
        </a>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-10">
          {navLinks.map((link) => (
            <button
              key={link.href}
              onClick={() => scrollTo(link.href)}
              data-testid={`nav-link-${link.label.toLowerCase().replace(/\s/g, '-')}`}
              className="text-white/90 hover:text-[#b39a73] transition-colors duration-300 text-base tracking-[0.2em] uppercase font-medium"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              {link.label}
            </button>
          ))}
          <button
            onClick={() => scrollTo("#contact")}
            data-testid="nav-cta-devis"
            className="border border-[#b39a73] text-[#b39a73] px-6 py-2.5 text-base tracking-[0.15em] uppercase hover:bg-[#b39a73] hover:text-white transition-all duration-300"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            Demander un devis
          </button>
        </div>

        {/* Mobile Hamburger */}
        <Sheet open={mobileOpen} onOpenChange={setMobileOpen}>
          <SheetTrigger asChild className="md:hidden">
            <button data-testid="mobile-menu-btn" className="text-white p-2">
              <Menu className="h-6 w-6" />
            </button>
          </SheetTrigger>
          <SheetContent side="right" className="bg-[#2E3A34] border-none w-72">
            <SheetTitle className="sr-only">Menu de navigation</SheetTitle>
            <div className="flex flex-col gap-8 mt-12">
              {navLinks.map((link) => (
                <button
                  key={link.href}
                  onClick={() => scrollTo(link.href)}
                  data-testid={`mobile-nav-${link.label.toLowerCase().replace(/\s/g, '-')}`}
                  className="text-white/90 hover:text-[#b39a73] text-left text-lg tracking-[0.15em] uppercase transition-colors"
                  style={{ fontFamily: "'Cinzel', serif" }}
                >
                  {link.label}
                </button>
              ))}
              <button
                onClick={() => scrollTo("#contact")}
                data-testid="mobile-cta-devis"
                className="border border-[#b39a73] text-[#b39a73] px-6 py-3 text-sm tracking-[0.15em] uppercase hover:bg-[#b39a73] hover:text-white transition-all mt-4"
                style={{ fontFamily: "'Cormorant Garamond', serif" }}
              >
                Demander un devis
              </button>
            </div>
          </SheetContent>
        </Sheet>
      </div>
    </nav>
  );
}
